// extracted by mini-css-extract-plugin
export var option = "_56-1";
export var optionActive = "_56-2";
export var pill = "_56-0";